import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;

  inline-size: 600px;
  min-block-size: 252px;
  margin: auto;
  padding-block: 40px;
  padding-inline: 0;

  border-radius: 8px;

  background-color: #ffffff;

  outline: none;
`;
